import React, { Component } from 'react';
import Panel from '../../../../../../components/angle/Panel/index';
import { Tabs, Tab } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Spinner from '../../../../../../components/Spinner/index';
import PortfolioForm from '../../../../components/PortfolioForm';

import {
    fetchFundTypes,
    fetchStates,
    fetchCountries
} from '../../../../../../services/redux/commonData/actions';
import {
    editPortfolio,
    updateEditPortfolioPayload,
    updatePortfolioHistoryItemSelected,
    handleEditPortfolioVisibility
} from '../../../../../../services/redux/employee/portfolio/actions';
import { formInputValidation } from '../../../../../../services/helper/form-helper';

class EditPortfolio extends Component {
    constructor(props) {
        super(props);
        this.portfolioFormRef = React.createRef();
    }

    componentDidMount() {
        let { fetchFundTypes, fetchStates, fetchCountries } = this.props;
        fetchFundTypes();
        fetchStates();
        fetchCountries();
    }

    onSaveClick = () => {
        let {
            portfolio,
            handleEditPortfolioVisibility,
            editPortfolio
        } = this.props;
        let payload = portfolio.editPortfolio;
        if (formInputValidation(this.portfolioFormRef.current)) {
            editPortfolio(payload).then(response => {
                if (response.status === 200) {
                    handleEditPortfolioVisibility(false);
                }
            });
        }
    };

    onBackClick = () => {
        let { handleEditPortfolioVisibility, location, history } = this.props;
        if (location.from) {
            history.push({
                pathname: location.from,
                from: '/client-details'
            });
        } else {
            handleEditPortfolioVisibility(false);
        }
    };

    render() {
        let { portfolio, commonData, updateEditPortfolioPayload } = this.props;
        let saveButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered green-button"
                onClick={this.onSaveClick}
            >
                Save
            </button>
        );

        let backButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered green-button"
                onClick={this.onBackClick}
            >
                Back
            </button>
        );

        return (
            <div className="panel">
                <Tabs
                    defaultActiveKey={1}
                    id="tabID"
                    mountOnEnter={true}
                    unmountOnExit={true}
                >
                    <Tab eventKey={1} title="Edit Portfolio">
                        <Panel>
                            <div className="col-lg-6 col-md-8 col-sm-12">
                                <PortfolioForm
                                    portfolioData={portfolio.editPortfolio}
                                    parentTrusts={portfolio.parentTrusts}
                                    fundTypeList={commonData.fundTypes}
                                    countryList={commonData.countries}
                                    stateList={commonData.states}
                                    updatePortfolioData={
                                        updateEditPortfolioPayload
                                    }
                                    formRef={this.portfolioFormRef}
                                />
                            </div>
                        </Panel>
                    </Tab>
                    <br />
                    {saveButton}
                    {backButton}
                </Tabs>
                {portfolio.fetching && <Spinner />}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    portfolio: state.employee.portfolio,
    commonData: state.commonData
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            editPortfolio,
            updateEditPortfolioPayload,
            updatePortfolioHistoryItemSelected,
            handleEditPortfolioVisibility,
            fetchFundTypes,
            fetchStates,
            fetchCountries
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(EditPortfolio));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/ClientDetails/screens/EditPortfolio/index.js